// All requests that deal with the app state

import { FeedbackDTO } from "@src/types/global";
import { api } from "@src/utils/axios-instance";

/**
  * Get all global app settings related to the API
  */
export async function getGlobalAppSettings() {
    const res = await api.get("global-settings")
    return res.data.data
}

// Submit feedback or a bug
export function submitFeedback(feedback: FeedbackDTO) {
    return api.post("feedback", feedback)
}
